import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { Form } from '../form/form-helpers/form';
import { CustomValidators } from '../form/form-helpers/validation/validators/custom-validators';
import { IFormModel } from '../form/form.model';

@Component({
  selector: 'app-multiple-radio-button-group',
  templateUrl: './multiple-radio-button-group.component.html',
})
export class MultipleRadioButtonGroupComponent<T>
  extends Form<T>
  implements OnInit, AfterViewInit
{
  @Input() inputs?: IFormModel[];
  @Input() prefix?: string = '';
  @Input() validatorKeys?: string[];

  @Input() switchButtonStrictValueKeys?: string;

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  radioGroup?: any;

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.prefix) {
      this.setTranslationPrefix(this.prefix);
    }

    this.registerComponents(this.inputs!);
    this.setRadioGroup(this.inputs![0]);
  }

  ngAfterViewInit(): void {
    if (this.validatorKeys) {
      this.formGroup?.setValidators(
        CustomValidators.atLeastOne(
          this.validatorKeys,
          'validators.oneRequired'
        ) as any
      );
      this.formGroup?.updateValueAndValidity();
    }
  }

  onChange(value: string, selected: IFormModel): void {
    this.formGroup?.reset();
    this.setValueForControl(selected.name, value);
    this.setRadioGroup(selected);
    const newValue = {type: value, subtype: selected.radioButtonKey}

    this.valueChange.emit(newValue);
  }

  switchButtonValueChange(value: any) {
    const found = this.inputs?.find(
      (element) => element.radioButtonKey === value
    );

    this.setRadioGroup(found!);
  }

  setRadioGroup(item: IFormModel): void {
    this.radioGroup = item;
  }
}
